import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class ContactRoute extends Route {
  @service keywords;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: 'Contact the RISE team to let us know about any problems you are '
            + 'experiencing, questions you have, or to provide input to guide future '
            + 'enhancements to RISE. We\'d like to know whether you were able to find '
            + 'the data you needed, what other data and features you\'d like to see, '
            + 'how you use the data and web portal, and how we can improve RISE.',
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(),
        },
      },
    ];
  }

  @breadcrumb crumb = 'Contact Us';

  model() {
    return {
      entityOptions: [
        { value: 'Govt - Federal', text: 'Govt - Federal' },
        { value: 'Govt - State', text: 'Govt - State' },
        { value: 'Govt - Regional/Local', text: 'Govt - Regional/Local' },
        { value: 'Research Institution', text: 'Research Institution' },
        { value: 'Academic Institution', text: 'Academic Institution' },
        { value: 'Private Sector', text: 'Private Sector' },
        { value: 'Non-Govt - Organization', text: 'Non-Govt - Organization' },
        { value: 'Other', text: 'Other' },
      ],
      applicationOptions: [
        { value: 'Research', text: 'Research' },
        { value: 'Environmental Documentation', text: 'Environmental Documentation' },
        { value: 'Endangered Species consultation', text: 'Endangered Species consultation' },
        { value: 'Vulnerability Assessment', text: 'Vulnerability Assessment' },
        { value: 'Adaptation Planning', text: 'Adaptation Planning' },
        { value: 'Other', text: 'Other' },
      ],
      sectorOptions: [
        { value: 'Water Quantity', text: 'Water Quantity' },
        { value: 'Water Quality', text: 'Water Quality' },
        { value: 'Flood Management', text: 'Flood Management' },
        { value: 'Energy', text: 'Energy' },
        { value: 'Air Quality', text: 'Air Quality' },
        { value: 'Ecosystem - Land', text: 'Ecosystem - Land' },
        { value: 'Ecosystem - Aquatic', text: 'Ecosystem - Aquatic' },
        { value: 'Social Systems', text: 'Social Systems' },
        { value: 'Other', text: 'Other' },
      ],
      topics: [
        'Catalog',
        'Map',
        'Query',
        'Feature Request',
        'Data Requests and Issues',
        'Bug Report',
        'Help',
        'API',
        'Other',
      ],
    };
  }
}
